import React, { useRef } from 'react'
import PrivacyStatement from '../Common/PrivacyStatement'
import MainFormContentful, {
  MainFormContentfulProps
} from '@toasttab/shared/src/components/molecules/Contentful/Form/MainFormContentful'
import DemoFormJSON from './DemoFormJSON.json'

interface DemoFormProps {
  fieldIdPrefix: string
  formData?: any
  heapInteractionSubmit?: string
  privacyStatementCenter?: boolean
  useRecaptcha?: boolean
}

const DemoForm = ({
  fieldIdPrefix,
  formData = null,
  heapInteractionSubmit,
  privacyStatementCenter,
  useRecaptcha
}: DemoFormProps) => {
  const ref = useRef(null)

  const finalFormData =
    formData ||
    (JSON.parse(JSON.stringify(DemoFormJSON)) as MainFormContentfulProps)

  return (
    <div ref={ref}>
      <MainFormContentful
        {...finalFormData}
        componentContext='ContentfulMdsShowcaseForm'
        fieldIdPrefix={fieldIdPrefix}
        heapInteractionSubmit={
          heapInteractionSubmit ? heapInteractionSubmit : 'hpbottomdemo_submit'
        }
        useRecaptcha={useRecaptcha}
      />
      <PrivacyStatement
        data={finalFormData?.disclaimerSection}
        center={privacyStatementCenter}
      />
    </div>
  )
}

export default DemoForm
